import { ListActionHandlerBase } from '@aston/foundation';

export class ListActionHandler extends ListActionHandlerBase {
}
